import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";
import { type IRouteLocationState } from "utilities/flatRoutes/usePreviousLocation/usePreviousLocation.types";

import { type LeadTabNames } from "entity/lead/Lead/Lead.api.types";

interface ILeadDetailParams {
    leadId: number;
}

interface ILeadDetailQueryParams {
    selectedTab?: LeadTabNames;
    showRelatedJob?: boolean;
    showAddressMap?: boolean;
}

export const leadDetailPath = "/LeadPage/:leadId";
export const leadDetailRoute = createRoute<ILeadDetailParams, ILeadDetailQueryParams>(
    getPathForAllPortals(leadDetailPath),
    "Lead Opportunity",
);

/**
 * Location state the legacy `<list>/Lead/:id` redirect adds. Its replace keys the new entry, which
 * hides a deep link from `isDeepLinkEntry`, so the redirect records it for the page's back button.
 */
export interface ILeadPageRedirectState {
    openedByDeepLink?: boolean;
}

/**
 * Link to a child modal (a proposal, an activity) that opens over the lead page. The page link's
 * previous-location state is kept so the lead still knows where it came from.
 * @param childPath the child route, e.g. `routes.leadProposals.getDetailsLink(...)`
 */
export function leadChildLink(leadId: number, childPath: string): IRouteLocationState {
    const pageLink = leadDetailRoute.link({ leadId }) as IRouteLocationState;
    return { ...pageLink, pathname: pageLink.pathname + childPath };
}
